import { useQuery } from 'react-query';
import { useAPI } from '@axo/shared/data-access/provider';
import { ace_api } from '@axo/shared/data-access/api';
import { axoVersionsKeys } from '../../cache-keys/axoVersionsKeys';

export function useAxoVersion(loanApplicationID?: string) {
  const api = useAPI();

  return useQuery({
    queryKey: [axoVersionsKeys.application(loanApplicationID)],
    queryFn: () =>
      ace_api.getAxoVersion(api)({
        applicationID: loanApplicationID ?? '',
      }),
    enabled: !!loanApplicationID && api.token !== '',
    retry: false,
    refetchOnWindowFocus: false,
  });
}
